import React, { useEffect, useState } from "react";
import { PiBellBold } from "react-icons/pi";
import LogoNectar from "../assets/logo/LogoNectar";
import { Avatar, Drawer, IconButton } from "@mui/material";
import { IoMdArrowDropdown } from "react-icons/io";
import { useSelector } from "react-redux";
import AccountPopover from "./ui-elements/AccountPopover";
import { Link } from "react-router-dom";
import NavDrawerElements from "./navbar/NavDrawerElements";

const translatedRoles = {
  SuperAdmin: "Administrador",
  EcosystemEditor: "Editor de ecosistema",
  StoreEditor: "Editor de tienda",
};

const NavBar = ({ handleLogout }) => {
  const user = useSelector((state) => state.auth.user);
  const [openPopover, setOpenPopover] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [navbarOffset, setNavbarOffset] = useState(0);

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      const delta = currentScroll - scrollPosition;

      if (currentScroll === 0) {
        // Mostrar completamente cuando estamos arriba
        setNavbarOffset(0);
      } else if (delta > 0) {
        // Ocultar la navbar al bajar
        setNavbarOffset((prev) => Math.min(prev + delta, 80));
      } else if (delta < 0) {
        // Mostrar la navbar al subir
        setNavbarOffset((prev) => Math.max(prev + delta, 0));
      }

      setScrollPosition(currentScroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollPosition]);

  return (
    <nav
      style={{ transform: `translateY(-${navbarOffset}px)` }}
      className="fixed z-50 top-0 w-full bg-white  border-b-0.5 border-accent-green md:px-24 px-[15px] py-2 transition-transform duration-200 ease-in-out"
    >
      <div className="flex flex-row justify-between items-center">
        <div className="flex">
          <Link to="/home">
            <LogoNectar />
          </Link>
        </div>
        <Drawer
          open={showDrawer}
          onClose={() => setShowDrawer(false)}
          anchor="right"
          className="p-4"
        >
          <NavDrawerElements
            user={user}
            handleLogout={handleLogout}
            closeDrawer={() => setShowDrawer(false)}
          />
        </Drawer>
        <div className="md:hidden">
          <button
            className="text-dark-green"
            onClick={() => setShowDrawer(true)}
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>
        <div className="hidden md:flex flex w-fit justify-between items-center">
          <div className="flex items-center gap-2">
            <IconButton
              sx={{
                width: 40,
                height: 40,
              }}
            >
              <Avatar
                src={
                  user?.profileImage?.url
                    ? process.env.REACT_APP_SERVER + user.profileImage.url
                    : null
                }
                alt={"Perfil"}
                sx={{
                  width: 36,
                  height: 36,
                  border: (theme) =>
                    `solid 2px ${theme.palette.background.default}`,
                }}
              >
                {user.name.charAt(0).toUpperCase()}
              </Avatar>
              <IoMdArrowDropdown />
            </IconButton>
            <AccountPopover
              open={Boolean(openPopover)}
              anchorEl={openPopover}
              handleClose={handleClosePopover}
              handleLogout={handleLogout}
            />
            <div className="flex items-center gap-2">
              <div className="flex flex-col justify-start items-start">
                <span className="font-poppins font-bold">{user.name}</span>
                <span className="font-poppins text-xs text-average-gray">
                  {translatedRoles[user.role]}
                </span>
              </div>
              <IoMdArrowDropdown
                className="hover:cursor-pointer"
                onClick={handleOpenPopover}
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
